import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Spinner from '../Spinner/SpinnerNew';
import MicroFrontendContainer from './MicrofrontendContainer';
import { viewHistoryPlans } from '../../Modules/Maintain/tBillRates/store/actions';
import { viewHistoryTableHead } from '../../Modules/Maintain/tBillRates/Components/gridComponents/viewHisTableHead';

export default function ViewHistoryComponent(props) {
  const dispatch = useDispatch();
  const fetchAllViewHistoryList = (value) => {
    return dispatch(viewHistoryPlans(value));
  };
  const viewHistoryListData = useSelector(
    (state) => state.sharedState.TBillTableReducer.planViewHistory
  );
  const UserDefaultValues = useSelector(
    (state) => state.sharedState.UserDefaultReducer.UserDefaultsValues.data
  );
  const spinnerLoader = useSelector((state) => {
    return state?.sharedState.showPreLoader?.showPreLoader;
  });
  const {
    tableName,
    keyValue,
    columnNames,
    setShowViewHistory,
    allocatePayment,
    isSpinner,
  } = props;
  const [state, setState] = React.useState(false);
  React.useEffect(() => {
    fetchAllViewHistoryList(null);
    fetchAllViewHistoryList(
      allocatePayment
        ? keyValue
        : [
            columnNames
              ? {
                  tableName: tableName,
                  keyValue: keyValue,
                  columnNames: columnNames,
                }
              : {
                  tableName: tableName,
                  keyValue: keyValue,
                },
          ]
    );
  }, []);
  React.useEffect(() => {
    setState(true);
    if (props.setSpinner) props.setSpinner(false);
  }, [viewHistoryListData]);
  const setDefaultValues = () => {
    fetchAllViewHistoryList(null);
    setState(false);
  };

  return (
    <div>
      {isSpinner ? <Spinner load={spinnerLoader} /> : null}
      {viewHistoryListData !== null && state ? (
        <MicroFrontendContainer
          id="plan-search-cri-viewhistory"
          setShowViewHistory={setShowViewHistory}
          viewHistoryListData={viewHistoryListData || []}
          cellViewHistoryHead={viewHistoryTableHead || []}
          setDefaultValues={setDefaultValues}
          UserDefaultValues={UserDefaultValues}
          type="ViewHistory"
        />
      ) : null}
    </div>
  );
}
